import translations from './translation'
import axios from 'axios';
import GetPagesData from "./Routes";
import config from '../config.js';
import { toast } from 'react-toastify';

export function trans(key) {
    let lang = localStorage.getItem('lang') || "en"
    return translations[lang][key] ? translations[lang][key] : key
}

/**
 * Opens the Centered, Scrollable Error Modal
 * Designed specifically for Upload errors, multi-row Excel import validation, or long error logs.
 */
export function showErrorModal(errOrMsg, title = 'Errors Detected') {
    window.dispatchEvent(
        new CustomEvent('aeonShowErrorModal', {
            detail: {
                errors: errOrMsg,
                title: trans(title)
            }
        })
    );
}

/**
 * Global standardized Error notification:
 * - Automatically routes large/bulk errors (>2 lines or Laravel validation arrays) to the Centered Scrollable Error Modal
 * - Displays quick single errors in top-center toast
 * - Fully localized
 */
export function showError(errOrMsg, fallbackMsg = 'An error occurred') {
    // If it's a multi-field or multi-row validation error from backend, open the Centered Error Modal
    if (errOrMsg?.response?.data?.errors) {
        showErrorModal(errOrMsg, 'Validation Errors');
        return;
    }

    let error = '';
    if (typeof errOrMsg === 'string') {
        error = trans(errOrMsg);
    }

    if (!error && Array.isArray(errOrMsg?.response?.data?.message)) {
        if (errOrMsg.response.data.message.length > 2) {
            showErrorModal(errOrMsg, 'Errors Detected');
            return;
        }
        error = errOrMsg.response.data.message.join('\n');
    } else if (!error && typeof errOrMsg?.response?.data?.message === 'string') {
        error = errOrMsg.response.data.message;
    } else if (!error && errOrMsg?.response?.data?.msg) {
        error = errOrMsg.response.data.msg;
    } else if (!error && errOrMsg?.response?.data?.error) {
        error = typeof errOrMsg.response.data.error === 'string' ? errOrMsg.response.data.error : JSON.stringify(errOrMsg.response.data.error);
    } else if (!error && errOrMsg?.message) {
        error = errOrMsg.message;
    } else if (!error) {
        error = trans(fallbackMsg);
    }

    // If message contains more than 3 newline-separated errors, open Modal for better readability
    if (typeof error === 'string' && error.split('\n').filter(Boolean).length > 3) {
        showErrorModal(error, 'Errors Detected');
        return;
    }

    toast.error(error, {
        position: 'top-center',
        autoClose: false,
        closeButton: true,
        closeOnClick: false,
        style: { whiteSpace: 'pre-line' }
    });
}

/**
 * Global standardized Success notification:
 * - Positioned at top-center
 * - Auto-closes after 3.5 seconds
 * - Close button ('x') enabled
 * - Fully localized
 */
export function showSuccess(msg = 'Success') {
    toast.success(trans(msg), {
        position: 'top-center',
        autoClose: 3500,
        closeButton: true
    });
}


export function resetPermissions(CurrentModule) {
    const SystemUrl = config.SystemUrl;
    axios.get(`${SystemUrl}getPermissions`).then(res => {

        var pages=res.data.data;
        var lang = localStorage.getItem('lang') || "en";
        var styleUrl = localStorage.getItem('styleUrl') || "/assets/css/main-modular.css"

        localStorage.clear();
        localStorage.setItem('lang',lang)
        localStorage.setItem('styleUrl',styleUrl)
        localStorage.setItem('isLoggedIn', true)
        GetPagesData(pages);
        window.location.href = '/'+CurrentModule;

    })
}

export function getCustomModules(){
    return [
        {
            route: "AssetItem/View/:id",
            name_en: trans("AssetItem View"),
            module : 'AssetItem'
        },
        {
            route: "Customer/View/:id",
            name_en: trans("Customer View"),
            module : 'Customer'
        },
        {
            route: "Project/View/:id",
            name_en: trans("Project View"),
            module : 'Project'
        }
        ,
        {
            route: "Ticket/View/:id",
            name_en: trans("Ticket Information"),
            module : 'Ticket'
        },
        {
            route: "WorkOrder/View/:id",
            name_en: trans("WorkOrder Information"),
            module : 'WorkOrder'
        },
        {
            route: "Profile/:id",
            name_en: trans("Profile"),
            module : 'Profile'
        },
        {
            route: "RoomSpaceItem/View/:id",
            name_en: trans("Allocate Asset / Item"),
            module : 'RoomSpaceItem'
        },
        {
            route: "MyAsset/View/:id",
            name_en: trans("My Asset"),
            module : 'MyAsset'
        },
        {
            route: "AssignAssetItem/View/:id",
            name_en: trans("Assign Asset / Item"),
            module : 'AssignAssetItem'
        },
        {
            route: "Contract/View/:id",
            name_en: trans("Contract Details"),
            module : 'Contract'
        },
        {
            route: "InventoryTaking/View/:id",
            name_en: trans("Inventory Taking"),
            module : 'InventoryTaking'
        },
        {
            route: "InventoryTaking/Scan/:it_id",
            name_en: trans("Inventory Taking"),
            module : 'Scan',
        },
        {
            route: "InventoryTaking/AssetItemList/:it_id/:room_id",
            name_en: trans("Asset / Item List"),
            module : 'AssetItemList',
        },
        {
            route: "InventoryTaking/Charts/:it_id/:room_id",
            name_en: trans("Inventory Taking Charts"),
            module : 'finishTaking',
        },
        {
            route: "Space/View/:id",
            name_en: trans("Space"),
            module : 'Space',
        },
        {
            route: "ActivityLog/:page/:id",
            name_en: trans("ActivityLog"),
            module : 'ActivityLog',
        },
        {
            route: "ActivityLogPerUser/:user_id",
            name_en: trans("ActivityLogPerUser"),
            module : 'ActivityLogPerUser',
        }
        
    ];
}
